export default __webpack_public_path__ + "static/mocca-8eaeac1c584a1be1625bee4aade79ca2.png";